import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const globalEnhancedModalStyles = css`
  .enhanced-modal .ant-modal-content {
    padding: 0;
  }
`;

export const SHeader = styled.header`
  background: #f5f5f5;
  padding: 16px;
`;

export const SBody = styled.div`
  padding: 16px;
`;

export const SFooter = styled.footer<{ bt: boolean }>`
  padding-top: 0;
  padding: 16px;
  ${({ bt }): string => bt ? 'border-top: 1px solid rgba(0, 0, 0, 0.06);' : ''}
`;

export const STitle = styled.span`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 28px;
  color: rgba(0, 0, 0, 0.85);
`;
